/**
 * "Languages & RTL" — Introduction section (ADR-0074).
 * Structure + `docs.*` keys only; prose lives in the per-locale catalogs.
 * Source: `product/trust/localization-rtl.md`, `packages/shared/src/i18n/locales.ts`.
 */
import type { DocPageContent } from '../types';

export const LANGUAGES_PAGE: DocPageContent = {
  slug: 'languages',
  titleKey: 'docs.languages.title',
  descriptionKey: 'docs.languages.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.languages.lead' },

    { kind: 'heading', level: 2, id: 'supported', textKey: 'docs.languages.supported.heading' },
    {
      kind: 'list',
      itemKeys: [
        'docs.languages.supported.item.en',
        'docs.languages.supported.item.es',
        'docs.languages.supported.item.fr',
        'docs.languages.supported.item.de',
        'docs.languages.supported.item.ar',
        'docs.languages.supported.item.he',
      ],
    },

    { kind: 'heading', level: 2, id: 'everywhere', textKey: 'docs.languages.everywhere.heading' },
    { kind: 'paragraph', textKey: 'docs.languages.everywhere.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.languages.everywhere.item.ui',
        'docs.languages.everywhere.item.chat',
        'docs.languages.everywhere.item.server',
        'docs.languages.everywhere.item.prompts',
      ],
    },

    { kind: 'heading', level: 2, id: 'rtl', textKey: 'docs.languages.rtl.heading' },
    { kind: 'paragraph', textKey: 'docs.languages.rtl.body' },

    { kind: 'heading', level: 2, id: 'detection', textKey: 'docs.languages.detection.heading' },
    { kind: 'paragraph', textKey: 'docs.languages.detection.body' },
    {
      kind: 'list',
      ordered: true,
      itemKeys: [
        'docs.languages.detection.item.explicit',
        'docs.languages.detection.item.browser',
        'docs.languages.detection.item.fallback',
      ],
    },

    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.languages.coming.title',
      textKey: 'docs.languages.coming.body',
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.languages.next.glossary.title',
          textKey: 'docs.languages.next.glossary.text',
          to: { docSlug: 'glossary' },
        },
        {
          titleKey: 'docs.languages.next.howItWorks.title',
          textKey: 'docs.languages.next.howItWorks.text',
          to: { docSlug: 'architecture' },
        },
      ],
    },
  ],
};
